// extracted by mini-css-extract-plugin
module.exports = {"counter":"contentFt_counter__3Ip62","comments":"contentFt_comments__1I7rB","buttons":"contentFt_buttons__3ZoeP"};